import React, { useState } from 'react';
import './FEFaq.css';

export const faqs = [
    {
        question: '¿Qué es un Comprobante Fiscal Electrónico (e-CF)?',
        answer:
            'Un e-CF es un documento electrónico firmado digitalmente que certifica la transferencia de bienes, entrega en uso o prestación de servicios. Tiene la misma validez legal que una factura impresa, pero cumple con los requisitos del Decreto 254-06 y la Ley 32-23 de forma digital.',
    },
    {
        question: '¿Cuándo es obligatorio facturar electrónicamente?',
        answer:
            'La Ley 32-23 estableció un calendario escalonado: los grandes y medianos contribuyentes ya están obligados, y el plazo final para que micro, pequeñas empresas y contribuyentes no clasificados emitan e-CF vence el 15 de noviembre de 2026. Las empresas que no cumplan se exponen a sanciones de 5 a 30 salarios mínimos. Le ayudamos a confirmar el grupo y la fecha que le aplica según la DGII.',
    },
    {
        question: '¿Necesito un certificado de firma digital?',
        answer:
            'Sí. La Ley 126-02 establece que solo la firma digital basada en un certificado emitido por una entidad autorizada (DigiFirma o ViaFirma) tiene validez fiscal. Dicho certificado tiene validez cada 12 meses.',
    },
    {
        question: '¿Necesito saber de contabilidad para usar el sistema?',
        answer:
            'No. El sistema te guía paso a paso para emitir e-CF sin conocimientos contables. Solo necesitas los datos del comprador, la descripción del producto o servicio, y el monto. El software se encarga del formato XML, la firma digital y la transmisión a la DGII.',
    },
    {
        question: '¿Existe algún beneficio por implementar antes del plazo?',
        answer:
            'Sí. Las empresas que implementen la facturación electrónica antes del plazo obligatorio pueden acceder a un crédito fiscal por adopción temprana, aplicable a un único impuesto: ISR, ITBIS, Anticipos ISR o ISA.',
    },
    {
        question: '¿Puedo migrar mis datos desde otro sistema?',
        answer:
            'Sí. Ofrecemos migración gratuita de datos desde otros sistemas de facturación, incluyendo catálogos de clientes con validación de RNC, productos e historial de transacciones. Nuestro equipo se encarga de todo el proceso.',
    },
    {
        question: '¿El sistema incluye POS y CRM?',
        answer:
            'Sí. Los planes PYME y Empresarial incluyen un punto de venta (POS) integrado que genera e-CF en cada transacción, y un CRM para gestionar clientes, cuentas por cobrar y seguimiento comercial.',
    },
    {
        question: '¿Mis datos están seguros?',
        answer:
            'Absolutamente. Utilizamos encriptación SSL de 256 bits y servidores certificados. Los e-CF se almacenan de forma segura por el período de 10 años requerido por la normativa vigente. Tus datos nunca se comparten con terceros.',
    },
];

const FEFaq = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    return (
        <section id="fe-faq" className="fe-faq">
            <div className="container">
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-7 text-center">
                        <span className="fe-faq__label">FAQ</span>
                        <h2 className="fe-faq__heading">Preguntas Frecuentes</h2>
                        <p className="fe-faq__subheading">
                            Resolvemos tus dudas comunes antes de empezar
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="fe-faq__list">
                            {faqs.map((faq, index) => {
                                const isOpen = openIndex === index;
                                return (
                                    <div
                                        key={index}
                                        className={`fe-faq__item${isOpen ? ' fe-faq__item--open' : ''}`}
                                    >
                                        <button
                                            className="fe-faq__question"
                                            onClick={() => toggle(index)}
                                            aria-expanded={isOpen}
                                        >
                                            <span className="fe-faq__question-icon">
                                                <i className="fas fa-check-circle"></i>
                                            </span>
                                            <span className="fe-faq__question-text">
                                                {faq.question}
                                            </span>
                                            <span className="fe-faq__chevron">
                                                <i
                                                    className={`fas ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                                ></i>
                                            </span>
                                        </button>

                                        {isOpen && (
                                            <div className="fe-faq__answer">
                                                <p>{faq.answer}</p>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        <div className="text-center mt-5">
                            <p className="fe-faq__cta-text">
                                ¿Tienes más preguntas? Estamos aquí para ayudarte.
                            </p>
                            <a href="https://wa.me/18096050699" className="btn btn-fe-primary fe-faq__cta-btn">
                                Quiero hablar con un asesor
                                <i className="fas fa-arrow-right ml-2"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FEFaq;
